import {
  createMinLengthRegex,
  LOWERCASE_AND_UPPERCASE_REGEX,
  NUMBER_REGEX,
  STRONG_PASSWORD_REGEX,
  SYMBOL_REGEX
} from "@/constants/regex";
import { EToastType } from "@/hooks/ui/useToast";

import { PasswordFormData } from "./types";

export const PASSWORD_FORM_RULES = {
  password: {
    pattern: {
      value: STRONG_PASSWORD_REGEX,
      message: "" // The error message validation will be on checklist src/components/resetPassword/PasswordForm.tsx#L48.
    }
  },
  confirmPassword: {
    validate: (value: string, formValues: PasswordFormData) =>
      value === formValues.password ||
      "Password confirmation doesn't match Password"
  }
};

export const PASSWORD_FORM_COPY = {
  pageTitle: {
    createPassword: "Create Password",
    resetPassword: "Reset Your Password"
  },
  submitButton: {
    createPassword: "Create",
    resetPassword: "Update"
  }
};

export const PASSWORD_FORM_CHECKLIST = [
  {
    key: "minLength",
    label: "At least 8 characters.",
    regex: createMinLengthRegex(8)
  },
  {
    key: "lowerUpperCase",
    label: "Include both uppercase and lowercase letters.",
    regex: LOWERCASE_AND_UPPERCASE_REGEX
  },
  {
    key: "number",
    label: "Must contain a number.",
    regex: NUMBER_REGEX
  },
  {
    key: "symbol",
    label: "Use at least one special character (@, #, $, etc.)",
    regex: SYMBOL_REGEX
  }
];

export const PASSWORD_FORM_TOAST_CONFIG = (title: string, message: string) => ({
  successToast: {
    message: (
      <div className="flex flex-col gap-2 text-txtHeading">
        <div className="text-base font-semibold">{title}</div>
        <div className="text-sm">{message}</div>
      </div>
    ),
    type: EToastType.SUCCESS
  },
  errorToast: {
    message: (
      <div className="flex flex-col gap-2 text-txtHeading">
        <div className="text-base font-semibold">{title}</div>
        <div className="text-sm">{message}</div>
      </div>
    ),
    type: EToastType.ERROR
  }
});
